module.exports = __webpack_public_path__ + "img/friendbuy-landing-banner.6fc35741.webp";